<template>
  <div class="analytics-progress-bar-container" @click="$emit('click', $event)">
    <div class="analytics-progress-bar" :style="{ width: value + '%' }"></div>
    <div class="analytics-progress-bar-value">
      <slot />
    </div>
  </div>
</template>



<script>
export default {
  name: 'AnalyticsProgressBar',
  props: {
    value: {
      type: Number,
      default: 75
    }
  }
}
</script>
